module.exports = __webpack_public_path__ + "img/mju_logo.fde33ef5.png";